import { cn } from '@/lib/utils';
import { formatTime } from './slot-utils';
import type { AvailableSlot } from './schemas';

type Props = {
  slots: AvailableSlot[];
  selectedSlot: AvailableSlot | null;
  onSelect: (slot: AvailableSlot) => void;
  className?: string;
  style?: React.CSSProperties;
};

/**
 * 3-column grid of time-slot buttons for the currently selected date.
 * Selecting a slot only updates local "selected" visual state via `onSelect`
 * — booking happens on the parent's separate Confirm action.
 */
export function TimeSlotGrid({ slots, selectedSlot, onSelect, className, style }: Props) {
  return (
    <div className={cn('grid grid-cols-3 gap-2', className)} style={style}>
      {slots.map((slot) => {
        const isSelected = selectedSlot?.startTime === slot.startTime;
        return (
          <button
            key={slot.startTime}
            type="button"
            aria-pressed={isSelected}
            onClick={() => onSelect(slot)}
            className={cn(
              'rounded-md border px-3 py-2 text-sm font-medium transition-colors',
              isSelected
                ? 'border-primary bg-primary text-primary-foreground'
                : 'border-border bg-card text-card-foreground hover:bg-accent',
            )}
          >
            {formatTime(slot.startTime)}
          </button>
        );
      })}
    </div>
  );
}
